export default {
  AddToHome: {
    AppName: 'EMIS Ôn tập',
    SettingDescription: 'Cài đặt ứng dụng EMIS ôn tập để nhận và làm bài tập nhanh hơn'
  }
}
